import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "export-modal" }
const _hoisted_2 = { class: "export-modal--in-progress" }
const _hoisted_3 = { class: "export-modal__message-carousel-container" }

import MessageCarousel from '@/components/export/MessageCarousel.vue'
import ExportProgressLoader from '@/components/export/ExportProgressLoader.vue'
import ExportComplete from '@/components/export/ExportComplete.vue'
import CancelExportOverlay from '@/components/export/CancelExportOverlay.vue'
import ChipTag from '@/components/gallery/ChipTag.vue'
import BackIcon from '@/assets/BackIcon.svg'
import { useExportStore, ExportStatus } from '@/store/export-store'
import { ref, watch } from 'vue'
import { CanvasRecorder } from '@/pixi/canvas-recorder'

export default /*#__PURE__*/_defineComponent({
  __name: 'ExportModal',
  props: {
    isModalOpen: { type: Boolean },
    canvasRecorder: null
  },
  emits: ["closeVideoExport"],
  setup(__props: any, { emit: emits }: { emit: ({
  (event: 'closeVideoExport'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { 
  isModalOpen: boolean,
  canvasRecorder: CanvasRecorder | null
};

const exportStore = useExportStore()



watch(() => exportStore.exportStatus, (exportStatus) => {
  if (exportStatus === ExportStatus.ERROR){ 
    closeVideoExport()
  }
})



const showCancelExportOverlay = ref(false)

const closeVideoExport = () => {
  if (showCancelExportOverlay.value
    || exportStore.exportStatus === ExportStatus.COMPLETE
    || exportStore.exportStatus === ExportStatus.ERROR) {
    showCancelExportOverlay.value = false
    props.canvasRecorder?.cancelRecordCanvas()
    emits('closeVideoExport')
    // Use a timeout here to wait for the close animation before reverting back to the export in progress screen.
    exportStore.exportStatus = ExportStatus.INACTIVE
  } else {
    showCancelExportOverlay.value = true
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ChipTag, {
      class: "export-modal__chiptag",
      text: "Back to editor",
      onClick: closeVideoExport
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(BackIcon))
      ]),
      _: 1
    }),
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(MessageCarousel, {
          class: "export-modal__message-carousel",
          "trigger-reset-timer": __props.isModalOpen
        }, null, 8, ["trigger-reset-timer"])
      ]),
      _createVNode(ExportProgressLoader, { class: "export-modal__export-progress-loader" })
    ], 512), [
      [_vShow, _unref(exportStore).exportStatus === _unref(ExportStatus).EXPORTING]
    ]),
    _createVNode(_Transition, { name: "export-modal__fade-transition" }, {
      default: _withCtx(() => [
        _withDirectives(_createVNode(ExportComplete, { onCloseOverlay: closeVideoExport }, null, 512), [
          [_vShow, _unref(exportStore).exportStatus === _unref(ExportStatus).COMPLETE]
        ])
      ]),
      _: 1
    }),
    _withDirectives(_createVNode(CancelExportOverlay, {
      onConfirm: closeVideoExport,
      onCancel: _cache[0] || (_cache[0] = ($event: any) => (showCancelExportOverlay.value = false))
    }, null, 512), [
      [_vShow, showCancelExportOverlay.value && _unref(exportStore).exportStatus != _unref(ExportStatus).COMPLETE]
    ])
  ]))
}
}

})